import { Component, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ENV_CONFIG } from 'src/app/core/injection.token';
import { NotificationService } from 'src/app/core/services/notification.service';
import { FileStoreAPIService } from 'src/app/extensions/services/api/file-store-api.service';
import { isNotEmpty } from 'src/app/extensions/utilities';

@Component({
  selector: 'app-special-offer-edit-files-modal',
  standalone: false,
  templateUrl: './special-offer-edit-files-modal.component.html',
  styleUrl: './special-offer-edit-files-modal.component.scss',
})
export class SpecialOfferEditFilesModalComponent {
  campaignDocuments: app.models.SpecialOfferXDocument[] = [];

  acceptExtensions: string = '';

  constructor(
    private _activeModal: NgbActiveModal,
    private readonly _notificationService: NotificationService,
    private readonly _translateService: TranslateService,
    private readonly _fileStoreAPIService: FileStoreAPIService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvConfigurationData
  ) {}

  changeHandler() {
    this._activeModal.close(this.campaignDocuments);
  }

  closeHandler() {
    this._activeModal.close(false);
  }

  uploadFileInStoreHandler(event: any, isAttachment: boolean) {
    let file = event.target.files[0] as File;
    let fileExtension = file.name.split('.').pop();
    event.target.value = null;

    const UPLOAD_ALLOWED_EXTENSIONS = isAttachment
      ? this._envConfig.ALLOWED_FILE_EXTENSIONS.DOCUMENTS
      : this._envConfig.ALLOWED_FILE_EXTENSIONS.IMAGES;

    this.acceptExtensions = UPLOAD_ALLOWED_EXTENSIONS.map(extension => '.' + extension.toLowerCase()).join(',');

    if (!fileExtension || !UPLOAD_ALLOWED_EXTENSIONS.includes(fileExtension.toLowerCase())) {
      this._notificationService.showWarning(
        this._translateService.instant('specialOffers.wizard.campaignDescription.wrongExtension'),
        this._translateService.instant('common.warning')
      );
      return;
    }

    const allowedFileSizeinBytes = this._envConfig.ALLOWED_FILE_SIZE * 1000000;
    if (file.size > allowedFileSizeinBytes) {
      this._notificationService.showWarning(
        this._translateService.instant('common.fileSizeExceeded', { maxSize: this._envConfig.ALLOWED_FILE_SIZE }),
        this._translateService.instant('common.warning')
      );
      return;
    }

    this.uploadFile(file);
  }

  removeFileHandler(index: number): void {
    this.campaignDocuments.splice(index, 1);
  }

  private uploadFile(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    this._fileStoreAPIService.postFile(formData).subscribe((responseFileUpload: any) => {
      if (isNotEmpty(responseFileUpload)) {
        let generatedFilesName = Object.keys(responseFileUpload);

        const reader = new FileReader();
        reader.onload = (event: any) => {
          this.campaignDocuments.push({
            documentName: responseFileUpload[generatedFilesName[0]],
            documentStoragePath: generatedFilesName[0],
            documentSize: event.total,
          } as app.models.SpecialOfferXDocument);
        };
        reader.readAsDataURL(file);
      }
    });
  }
}
